import * as React from "react";

import l10n from "diy/util/l10n";
import features = require("diy/util/features");
import StateButton from "./stateButton/StateButton";
import RaisedButton from "material-ui/RaisedButton";

/** @deprecated */
import NTFCenterObserver from "./NotifierObservers/NTFCenterObserver";
/** to remove when the old notifications are no longer used */

import Notifier from "./Notifier";
import SiteAdminObserver from "./NotifierObservers/SiteAdminObserver";
import {pagesEditorObserver} from "./NotifierObservers/PagesEditorObserver";
import {notificationCenterObserver} from "./NotifierObservers/NotificationCenterObserver";
import Status from "./Status";
import DataStorage from "./DataStorage";
import Backend, {BackendData, BackendCrawlableUrl, ImportType} from "./Backend";

import DialogController, {DialogActions} from "./DialogController";
import StartDialog from "./startDialog/StartDialog";
import TransferDialog from "./transferDialog/TransferDialog";
import AssistanceDialog from "./assistanceDialog/AssistanceDialog";

import ErrorView from "./transferDialog/views/ErrorView";
import RunningView from "./transferDialog/views/RunningView";
import SuccessView from "./transferDialog/views/SuccessView";
import WaitingView from "./transferDialog/views/WaitingView";
import LongerWaitingView from "./transferDialog/views/LongerWaitingView";
import AssistanceView from "./assistanceDialog/views/AssistanceView";

export default class ImportProcedure {
    private migrationDialogController: DialogController;
    private notifier: Notifier;
    private statusProvider: Status;
    private pollingInterval = 2000;
    private currentStatus: string;
    private crawlingUrl: string;
    private websiteId: string;

    openManagePages() {
        diy.editor.deeplinking.requestPath([
            {label: "siteadmin", params: "pages"}
        ]);
    }

    openContact() {
        diy.editor.deeplinking.requestPath([
            {label: "siteadmin", params: "contact"}
        ]);
    }

    openUpsellPopup() {
        diy.editor.tariffUpdate.openPopup({
            component: "siteAdminWebsiteMigration"
        });
    }

    goToControlPanel() {
        diy.util.redirector.redirectToLabel("control_panel_redirect_mywebsite_overview", true, false);
    }

    goToHomepage() {
        let homePageId: number = jimdoData.navigation.pages[0].pageId;
        let currentPageId: number  = parseInt(document.body.getAttribute("data-pageId"), 10);
        if (currentPageId !== homePageId) {
            location.href = cc_.properties.cmsUrl + "app/" + script_basisID + "/" + homePageId;
        }
    }

    setPollingInterval(pollingInterval = 2000) {
        this.pollingInterval = pollingInterval;
    }

    setWebsiteId(websiteId: string) {
        this.websiteId = websiteId;
    }

    setNotifier(n: Notifier) {
        this.notifier = n;
    }

    setStatusProvider(sp: Status) {
        this.statusProvider = sp;
    }

    getImportStatusFromData(data: BackendData): string {
        return this.statusProvider.getStatus(data["status-code"]);
    }

    getImportUrlFromData(data: BackendData): string {
        for (let i = 0; i < data["crawlable-urls"].length; i++) {
            let crawlableUrl: BackendCrawlableUrl = data["crawlable-urls"][i];

            switch (crawlableUrl.type) {
                case ImportType.WSC:
                case ImportType.WSB:
                    return crawlableUrl.url;

                default:
                    break;
            }
        }
        return null;
    }

    init(websiteId: string, notificationApi?: __Notification.Api) {
        let siteAdminObserver = new SiteAdminObserver;

        let importNotifier = new Notifier;
        importNotifier.registerObserver(pagesEditorObserver);
        importNotifier.registerObserver(siteAdminObserver);

        if (features("notificationsNG")) {
            importNotifier.registerObserver(notificationCenterObserver);
        } else {
            let notificationCenter = new NTFCenterObserver;
            notificationCenter.setNotificationType(15);
            notificationCenter.setNotificationApi(notificationApi);
            importNotifier.registerObserver(notificationCenter);
        }

        this.setNotifier(importNotifier);
        this.setStatusProvider(new Status());
        this.setWebsiteId(websiteId);

        this.processStatus();
    }

    processStatus() {
        Backend.getExternalImportData(this.websiteId)
            .then((data: BackendData) => {
                this.statusHandler(data);
            });
    }

    statusHandler(data: BackendData) {
        let newStatus = this.getImportStatusFromData(data);
        let statusHasChanged = (newStatus !== this.currentStatus);

        this.currentStatus = newStatus;
        this.crawlingUrl = this.getImportUrlFromData(data);

        if (this.currentStatus !== Status.ERROR) {
            DataStorage.clearMigrationErrorShowed();
        }

        switch (this.currentStatus) {
            case Status.INITIAL:
                if (!this.isTransferDialogOpened() && statusHasChanged) {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openStartDialog.bind(this)
                    });
                }
                break;

            case Status.SKIPPED:
                if (statusHasChanged) {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openStartDialog.bind(this)
                    });
                }
                break;

            case Status.RUNNING:
                if (statusHasChanged) {
                    this.updateTransferDialog(
                        <RunningView websiteUrl={this.crawlingUrl}/>,
                        true
                    );
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;

            case Status.RUNNING_LONGER:
                if (statusHasChanged) {
                    this.updateTransferDialog(
                        <WaitingView websiteUrl={this.crawlingUrl} />,
                        true
                    );
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;

            case Status.RUNNING_VERY_LONG:
                if (statusHasChanged) {
                    this.updateTransferDialog(
                        <LongerWaitingView websiteUrl={this.crawlingUrl} />,
                        true
                    );
                    this.notifier.notify({
                        status: this.currentStatus
                    });
                }
                setTimeout(this.processStatus.bind(this), this.pollingInterval);
                break;

            case Status.ERROR:
                if (!DataStorage.hasMigrationErrorShowed()) {
                    let supportHandler = () => {
                        this.closeTransferDialog();
                        this.openContact();
                    };
                    this.updateTransferDialog(
                        <ErrorView supportHandler={supportHandler}/>,
                        false,
                        [<RaisedButton
                            primary={true}
                            label={l10n("migration.error.button")}
                            onClick={this.closeTransferDialog.bind(this)} />]
                    );
                } else {
                    DataStorage.setMigrationErrorShowed();
                }
                this.notifier.notify({
                    status: this.currentStatus
                });
                break;

            case Status.SUCCESS:
                if (this.isTransferDialogOpened()) {
                    this.updateTransferDialog(
                        <SuccessView websiteUrl={this.crawlingUrl} />,
                        false,
                        [<StateButton
                            label={l10n("migration.transfer.success.button")}
                            onClick={() => location.reload()}
                            data-test="continue-import" />]
                    );
                } else {
                    this.notifier.notify({
                        status: this.currentStatus,
                        actionHandler: this.openAssistanceDialog.bind(this)
                    });
                }
                break;

            case Status.UPGRADEABLE:
                this.notifier.notify({
                    status: this.currentStatus,
                    actionHandler: this.openUpsellPopup.bind(this)
                });
                break;

            default:
                this.notifier.remove();
                break;
        }
    };

    openStartDialog() {
        let startDialogController = new DialogController();
        let startDialogSubmit = () => {
            Backend.startExternalImport(this.websiteId)
                .then(() => {
                    DataStorage.setMigrationStartTime();
                    startDialogController.close();
                    this.openTransferDialog();
                })
                .catch((error: string) => {
                    startDialogController.close();
                });
        };
        let startDialogCancel = () => {
            Backend.skipExternalImport(this.websiteId)
                .then(() => {
                    startDialogController.close();
                    this.processStatus();
                })
                .catch((error: string) => {
                    startDialogController.close();
                });
        };
        let startDialogDisclaimerCancel = () => {
            Backend.skipDisclaimer(this.websiteId)
                .then(() => {
                    startDialogController.close();
                    this.processStatus();
                })
                .catch((error: string) => {
                    startDialogController.close();
                });
        };
        startDialogController.open(
            <StartDialog onSubmit={startDialogSubmit}
                         onCancel={startDialogCancel}
                         onDisclaimerCancel={startDialogDisclaimerCancel}
                         url={this.crawlingUrl} />
        );
    }

    openTransferDialog(content = <RunningView websiteUrl={this.crawlingUrl} />) {
        if (! this.isTransferDialogOpened()) {
            this.migrationDialogController = new DialogController();
            this.migrationDialogController.open(<TransferDialog />, content)
                .then(() => {
                    this.processStatus();
                });
        }
    }

    updateTransferDialog(
        content: JSX.Element,
        reopen = false,
        actions?: DialogActions
    ) {
        if (this.isTransferDialogOpened()) {
            this.migrationDialogController.update(content, actions);
        } else if (reopen) {
            this.openTransferDialog(content);
        }
    }

    closeTransferDialog() {
        if (this.isTransferDialogOpened()) {
            this.migrationDialogController.close();
        }
    }

    isTransferDialogOpened() {
        return (typeof this.migrationDialogController !== "undefined");
    }

    openAssistanceDialog() {
        let assistanceDialogController = new DialogController();
        let assistanceButtonActionhandler = () => {
            assistanceDialogController.close();
        };
        let assistanceActionHandlers: Array<Function> = [
            () => {
                assistanceDialogController.close();
                this.goToHomepage();
            },
            () => {
                assistanceDialogController.close();
                this.openManagePages();
            },
            () => {
                this.goToControlPanel();
            }
        ];
        assistanceDialogController.open(
            <AssistanceDialog />,
            <AssistanceView websiteUrl={this.crawlingUrl}
                            buttonActionHandler={assistanceButtonActionhandler}
                            stepActionHandlers={assistanceActionHandlers} />
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/ImportProcedure.tsx
 **/